import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { ChevronForwardIcon } from "@jti/brand-icons/chevron-forward";
import styles from "./NavBar.module.scss";
export const LinkElementContent = ({ text }) => (_jsxs(_Fragment, { children: [_jsx("div", { className: styles.icon }), _jsx("span", { className: styles.text, children: text }), _jsx(ChevronForwardIcon, { className: classNames(styles.icons, styles.chevron) })] }));
//# sourceMappingURL=LinkElementContent.js.map